import styled from 'styled-components';
import { Button } from 'antd';

export const EmptyDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 1rem;
`;

export const EmptyDataText = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  margin: 0;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ConfigAlarmButton = styled(Button)``;

export const SeeAlarmButton = styled(Button)``;
